<template>
    <div>
        <v-toolbar dense color="primary" dark align="center">
            <v-row>
                <v-col cols="5" align="left">
                    <v-toolbar-title
                        >Generzione Codice QR Ospite</v-toolbar-title
                    >
                </v-col>
                <v-col cols="2">
                    <v-btn small light @click="generateQr">
                        <v-icon color="success">mdi-check</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="5" align="right">
                    <v-btn
                        small
                        light
                        @click="$router.push('/home/amministrazione')"
                    >
                        <v-icon color="error">mdi-keyboard-backspace</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-toolbar>
        <v-row class="px-5">
            <v-col cols="4">
                <v-text-field label="Nome" v-model="nome"></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field label="Cognome" v-model="cognome"></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-autocomplete
                    label="Azienda"
                    v-model="azienda"
                    :items="aziende"
                    item-text="ragione_sociale"
                    item-value="id_azienda"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import QRCode from "qrcode";
export default {
    name: "GenerazioneQrOspite",
    data() {
        return {
            nome: "",
            cognome: "",
            azienda: null,
            aziende: [],
        };
    },
    methods: {
        generateQr() {
            const tempObj = {
                nome: this.nome,
                cognome: this.cognome,
                azienda: this.azienda,
            };
            console.log(this.nome, this.cognome, this.azienda);
            let request = {
                controller: "global",
                method: "POST",
                richiesta: {
                    action: "encrypt",
                    token: localStorage.getItem("user_token"),
                    data: JSON.stringify(tempObj),
                },
            };
            this.$store.dispatch("api6", request).then((res) => {
                let canvas = document.createElement("canvas");
                const url = "https://guest.quickview.biz/home?str=" + encodeURIComponent(res.data.result);
                QRCode.toCanvas(canvas, url, function (error) {
                    if (error) console.error(error);
                    let a = document.createElement("a");
                    a.href = canvas.toDataURL();
                    a.download = "ospite.png";
                    document.body.appendChild(a);
                    a.click();
                });
            });
        },
        async getAziende() {
            var getAziende = {
                controller: "Modulo",
                method: "POST",
                richiesta: {
                    action: "getAzienda",
                    token: localStorage.user_token,
                },
            };

            await this.$store.dispatch("api", getAziende).then((res) => {
                this.aziende = res.data.result.azienda;
            });
        },
    },
    mounted(){
        this.getAziende();
    }
};
</script>
